// Shared vocabulary for the drive chain — the Drives page and the Daily
// Execution drawer must colour a rock class and spell a chainage the same way,
// or the same ground reads as two different things on two screens.

/**
 * Rock-class palette: geology convention, good→poor. Anything unmatched gets
 * the neutral brand tint rather than pretending to be a class.
 */
export const classColor = (label: string): string => {
  const match = /class[\s-]*([ivx]+)\b/i.exec(label || "");
  const roman = (match?.[1] || "").toUpperCase();
  return (
    {
      I: "#3e8a3e",
      II: "#66a03a",
      III: "#d9a545",
      IV: "#e07b39",
      V: "#c23934",
    }[roman] || "#5b7fd9"
  );
};

export const chLabel = (value: string | number | null | undefined) =>
  value === "" || value == null
    ? "—"
    : `CH ${Number(value).toLocaleString("en-IN", { maximumFractionDigits: 3 })}`;

/** Bare chainage, no 'CH' prefix — for a badge that already says it once. */
export const chNumber = (value: string | number | null | undefined) =>
  value === "" || value == null
    ? "—"
    : Number(value).toLocaleString("en-IN", { maximumFractionDigits: 3 });

/**
 * Do two chainage ranges claim any of the same ground? Touching end-to-start
 * (105 → 110 after 101 → 105) is NOT an overlap — that is how a drive advances.
 */
export const rangesOverlap = (
  aFrom: number,
  aTo: number,
  bFrom: number,
  bTo: number
): boolean => {
  const [a1, a2] = aFrom <= aTo ? [aFrom, aTo] : [aTo, aFrom];
  const [b1, b2] = bFrom <= bTo ? [bFrom, bTo] : [bTo, bFrom];
  return a1 < b2 && b1 < a2;
};
